export const CAT_UPDATE_STATE = "CAT_UPDATE_STATE"
export const CAT_MORE_PRODUCTS_LOADED = "CAT_MORE_PRODUCTS_LOADED"
export const CAT_PRODUCT_CREATED = "CAT_PRODUCT_CREATED"
export const CAT_PRODUCT_UPDATED = "CAT_PRODUCT_UPDATED"
export const CAT_PRODUCT_DELETED = "CAT_PRODUCT_DELETED"
export const CAT_CATEGORY_ORDER_UPDATE = "CAT_CATEGORY_ORDER_UPDATE"

